import { Box, Title } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useFeatures } from 'modules/core/hooks/useFeatures'
import i18n from 'modules/core/lib/i18n'

import AllVariablesTable from 'modules/documents/components/DocumentTemplates/Content/AllAvailableVariablesList/Table'
import variables from 'modules/documents/store/collections/variables'

const AllAvailableVariablesList = () => {
  const { has_dev_template_custom_fields } = useFeatures(['dev_template_custom_fields'])
  useAsyncData(() => {
    return Promise.all([
      variables.allVariables({ hasTemplateCustomFields: has_dev_template_custom_fields }),
    ])
  }, [has_dev_template_custom_fields])

  return (
    <>
      <Title
        description={i18n.t('documents.document_templates.variables_list.description_v2')}
        title=""
        variant="500"
      />
      <HelpCenterLink name="document_templates">
        {i18n.t('documents.document_templates.variables_list.learn_more')}
      </HelpCenterLink>
      <Box paddingY="s12">
        <AllVariablesTable />
      </Box>
    </>
  )
}
export default observer(AllAvailableVariablesList)
